import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import SessionLanding from './pages/SessionLanding/SessionLanding';
import SessionApp from './components/SessionApp/SessionApp';
import PlayerStats from './pages/PlayerStats/PlayerStats';
import Expenses from './pages/Expenses/Expenses';
import NotFound from './pages/NotFound/NotFound';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { SessionProvider } from './context/SessionContext';
import { MasterPlayerProvider } from './context/MasterPlayerContext';
import { ExpenseProvider } from './context/ExpenseContext';
import { PlayerProvider } from './context/PlayerContext';
import './App.scss';

const App = () => {
  return (
    <AuthProvider>
      <SessionProvider>
        <MasterPlayerProvider>
          <PlayerProvider>
            <ExpenseProvider>
              <div className="app">
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <SessionLanding />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/player-stats"
                    element={
                      <ProtectedRoute>
                        <PlayerStats />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/expenses"
                    element={
                      <ProtectedRoute>
                        <Expenses />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/session/:sessionId/*"
                    element={
                      <ProtectedRoute>
                        <SessionApp />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
            </ExpenseProvider>
          </PlayerProvider>
        </MasterPlayerProvider>
      </SessionProvider>
    </AuthProvider>
  );
};

export default App;